export const capitalizeLanguageCode = (langCode) => {
    if (!langCode) {
        return '';
    }
    const [part1, part2] = langCode.split('-');
    if (!part1 || !part2) {
        return langCode;
    }
    return `${part1}-${part2.toUpperCase()}`;
};
//# sourceMappingURL=capitalize-language-code.js.map